<div class="progress" [ngClass]="{'done': percentage >= 100}">
  <div [style.width]="percentage + '%'" class="inner"></div>
</div>